<span>
  {{ value }}
</span>
